import { useTrustedCreators } from "../lib/useTrustedCreators";

// Small "POTENTIAL ALPHA" pill with the AlphaApeing logo, shown when a coin's creator is trusted.
export const AlphaBadge = ({ creator, className = "", compact = false }) => {
  const { isAlpha } = useTrustedCreators();
  if (!isAlpha(creator)) return null;
  return (
    <span
      data-testid="alpha-badge"
      title="Made by a creator you trust"
      className={`inline-flex items-center gap-1 font-mono font-bold uppercase tracking-wide bg-[#C9A227]/15 text-[#F0C000] border border-[#C9A227]/50 ${compact ? "text-[9px] px-1 py-0.5" : "text-[10px] px-1.5 py-0.5"} ${className}`}
    >
      <img src="/logo.png" alt="" className="w-3 h-3 object-contain" />
      Potential Alpha
    </span>
  );
};

// Convenience hook to know if a creator is trusted (for highlight styling).
export const useAlpha = () => {
  const { isAlpha } = useTrustedCreators();
  return isAlpha;
};
